<template>
  <!-- 单个订单详细 -->
  <div class="contions">
    <!-- <Button>打印</Button> -->
    <div>
      <div class="one">
        <div>
          <p>Invoice To：</p>
          <p>用戶編號:{{ all.MemberID }}</p>
          <p>郵箱：{{ all.EMail }}</p>
          <p>聯系電話：{{ all.TelePhone }}</p>
          <!-- <p>
            收货方式：{{(all.ServiceType == 2 ? '送货上门':(all.ServiceType == 3?'自提点自取':'未知'))}}
            收貨方式：{{order}}
        </p> -->
        </div>
        <div>
          <p>收貨人：{{ all.CName }}</p>
          <p>姓名/電話/: {{ all.CName }} {{ all.Mobile }}</p>
          <p>
            <!-- 收货方式：{{(all.ServiceType == 2 ? '送货上门':(all.ServiceType == 3?'自提点自取':'未知'))}} -->
            收貨方式：{{ order }}
          </p>
          <!-- <p>支付/收貨方式：{{all.PayType}}</p> -->
          <p>收貨地址：{{ all.Address }}</p>
        </div>
      </div>
      <!-- <div v-for="(item,index) in allorder" :key="index">{{item}}</div> -->
      <div class="two">
        <h4>Your Invoice</h4>
        <div class="date">
          <table id="table" cellspacing="0">
            <tr>
              <td style="color:#fff">序號</td>
              <td style="color:#fff">快遞公司</td>
              <!-- <td>集包单号</td> -->
              <td style="color:#fff">快遞單號</td>
              <td style="color:#fff">貨倉編號</td>
              <td style="color:#fff">入庫時間</td>
              <td style="color:#fff">貨物品名</td>
              <td style="color:#fff">收費重</td>
              <td style="color:#fff">實重</td>
              <td style="color:#fff">圖片</td>
              <td style="color:#fff">備註</td>
            </tr>
            <tr v-for="(item, index) in allorder.QueryOrderToList" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.kdCom }}</td>
              <!-- <td></td> -->
              <td>{{ item.kdBillcode }}</td>
              <td>{{ item.WaveHouse }}</td>
              <td>{{ item.ddTime }}</td>
              <td>{{ item.Goods }}</td>
              <td v-if="item.Weight > item.sFareWeight">{{ item.Weight }}</td>
              <td v-else>{{ item.sFareWeight }}</td>
              <td>{{ item.Weight }}</td>
              <td>暫無圖片</td>
              <td>{{ item.Rem }}</td>
            </tr>
            <tr>
              <td>實際重量：</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>{{ all.Weight }}</td>
            </tr>
            <tr>
              <td>實際重量：</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>{{ all.Weight }}</td>
            </tr>
          </table>
          <div class="three">
            <p>Totals：</p>
            <div class="block">
              <p>積分抵扣：-￥{{ all.JFFree }}</p>
              <p>集運卷抵扣：-￥{{ all.Jyj_Money }}</p>
              <p>超長費：￥{{ all.longFee }}</p>
              <p>地址附加費：￥{{ all.OrterFree }}</p>
              <p>運單附加費：￥0.00</p>
            </div>
            <div class="block">
              <p>報稅手續費：￥{{ all.Bs_Free }}</p>
              <p>保價金額：￥{{ all.Bj_Money }}</p>
              <p>保價手續費：￥{{ all.Bj_Sxf }}</p>
              <p>代收貸款：DHS {{ all.Dshk }}</p>
              <p>貸款手續費：￥{{ all.Dshk_Sxf }}</p>
            </div>
            <div class="four">
              <div>
                <span>訂單運費：</span><span>￥{{ all.Z_Free }}</span>
              </div>
              <div>
                <span>費用總計：</span><span>￥{{ all.Fare }}</span>
              </div>
              <div>
                <span>實付費用：</span><span>￥{{ all.Fare }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      orderID: null,
      allorder: [],
      all: {},
      order: "",
    };
  },
  created() {
    this.order = this.$route.query.air_name;
    console.log(this.$route.query.air_name, "this.$route.query.air_name");
  },
  mounted() {
    this.orderID = this.$route.query.orderID;
    this.QueryOrderDetail();
  },
  methods: {
    async QueryOrderDetail() {
      const params = {
        MemberID: localStorage.getItem("userID"),
        ID: this.orderID,
      };
      const { data } = await this.$post("QueryOrderDetail", params);
      if (data.State) {
        this.allorder = JSON.parse(data.ReturnJson);
        console.log(this.allorder);
        this.all = JSON.parse(data.ReturnJson).QueryOrderDetail[0];
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.contions {
  width: 1069px;
  background: #fff;
  // height: 700px;
  padding: 20px 29px;
  .one {
    display: flex;
    flex-direction: row;
    margin: 15px 0 0 0;
    div p {
      line-height: 26px;
      cursor: pointer;
    }
    > div:nth-child(2) {
      margin: 0px 0 0 100px;
    }
  }
  .two {
    margin-top: 20px;
    h4 {
      font-weight: bold;
      font-size: 20px;
    }
    .date {
      margin: 0 0 0 30px;
      #table {
        width: 949px;
        cursor: pointer;
        tr {
          height: 40px;
        }
        tr:nth-child(1) {
          // background: #ccc;
          // background: linear-gradient(0deg, #ff920a 0%, #ffaf4b 100%);
          background: #4141a0;
          font-size: 14px;
          color: #fff !important;
          td {
            color: #000;
            font-size: 14px;
            font-weight: bold;
          }
        }
        td {
          width: 100px;
          font-size: 12px;
          text-align: center;
          border-bottom: 1px solid #ccc;
        }
        .td:nth-child(even) {
          background: #fff;
        }
        .td:nth-child(odd) {
          background: #f1f5fe;
        }
      }
    }
    .three {
      margin: 5px 0 0 0;
      > p {
        font-size: 16px;
        cursor: pointer;
        font-weight: bold;
      }
      .block {
        display: flex;
        flex-direction: row;
        p {
          cursor: pointer;
          margin: 0 20px;
          width: 150px;
          text-align: center;
        }
      }
    }
    .four {
      margin: 10px 0 0 0;
      div:nth-child(1) {
        background: #c3c3c3b8;
      }
      div:nth-child(2) {
        background: #c2c2c2;
      }
      div:nth-child(3) {
        // background: red;
        color: #fff;
         background: #4141a0;
      }
      div {
        width: 949px;
        height: 30px;
        background: #fff;
        span:nth-child(1) {
          float: left;
          line-height: 30px;
          padding: 0 5px;
        }
        span:nth-child(2) {
          float: right;
          line-height: 30px;
          padding: 0 5px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/view/homeManage/Detailedorder.vue